import React from 'react';
import Box from '@nubank/nuds-web/components/Box/Box';
import Typography from '@nubank/nuds-web/components/Typography/Typography';
import Link from '@nubank/nuds-web/components/Link/Link';
import Image from '@nubank/nuds-web/components/Image/Image';
import PropTypes from 'prop-types';

const MastercardBenefitsList = ({ partnersList, handleItemClick }) => (
  <Box
    display="flex"
    flexDirection="column"
    alignItems="center"
    background="linear-gradient(to bottom, white 0%, white 3%, #F8F8FA 3%, #F8F8FA 100%);"
  >

    {partnersList.map(partner => (
      <Box
        key={partner.id}
        borderRadius="12px"
        height={{ xs: '347px', md: 'auto' }}
        width="300px"
        display="flex"
        flexDirection="column"
        alignItems="center"
        justifyContent="space-between"
        paddingBottom={{ xs: '30px', md: '0' }}
        paddingTop={{ xs: '6x', md: '0' }}
        paddingHorizontal={{ xs: '19px', md: '0' }}
        backgroundColor="white.default"
        marginBottom="20px"
        onClick={() => handleItemClick(partner.id)}
      >
        <Image
          alt={partner.image.alt}
          src={partner.image.url}
          width={{ xs: '133px', md: 'auto' }}
          height={{ xs: '133px', md: 'auto' }}
          loading="lazy"
          objectFit="contain"
          webp
        />

        <Typography
          variant="heading4"
          strong
          marginTop="27px"
          marginBottom="35px"
          textAlign="center"
          totalChars={partner.title.length}
        >
          {partner.title}
        </Typography>

        {/* Link that works as a button ¯\_(ツ)_/¯ */}

        <Link
          href="###"
          alt="Ver beneficio"
          variant="action"
          iconProps={{
            name: 'arrow-right',
          }}
        >
          Ver beneficio
        </Link>
      </Box>
    ))}
  </Box>

);

MastercardBenefitsList.propTypes = {
  handleItemClick: PropTypes.func.isRequired,
  partnersList: PropTypes.arrayOf(
    PropTypes.shape({
      description: PropTypes.string,
      id: PropTypes.string,
      image: PropTypes.shape({
        alt: PropTypes.string,
        url: PropTypes.string,
      }),
      moreLink: PropTypes.string,
      title: PropTypes.string,
    }),
  ).isRequired,
};

export default MastercardBenefitsList;
